// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/routes/Landing/Landing.css */

.landing-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: white;
    height: 12vh;
    padding: 2rem;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.623);
}

.logo-landing {
    height: 3.25rem;
}

.landing-content {
    overflow-y: auto;
    height: 85vh;
    justify-content: center;
    align-items: center;
    color: #EF6F53;
}

.landing-heading {
    margin-top: 15%;
    font-size: 5rem;
    color: white;
    font-weight: 600;
}

.continue-link { 
    display: inline-block;
    margin-top: 20px;
    font-size: 1.5rem;
    color: #364C63; 
    color: white;
    text-decoration: none; 
    background-color: #d85939;
    padding: 10px; 
    border-radius: 10px; 
    transition: background-color 0.3s; 
    cursor: pointer;
}

.continue-link:hover {
    background-color: #fa3a0a; 
    transform: translateY(2px); 
}
`, "",{"version":3,"sources":["webpack://./src/components/routes/Landing/Landing.css"],"names":[],"mappings":"AAAA,8CAA8C;;AAE9C;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,0CAA0C;AAC9C;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,YAAY;IACZ,qBAAqB;IACrB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,iCAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B","sourcesContent":["/* src/components/routes/Landing/Landing.css */\n\n.landing-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background-color: white;\n    height: 12vh;\n    padding: 2rem;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.623);\n}\n\n.logo-landing {\n    height: 3.25rem;\n}\n\n.landing-content {\n    overflow-y: auto;\n    height: 85vh;\n    justify-content: center;\n    align-items: center;\n    color: #EF6F53;\n}\n\n.landing-heading {\n    margin-top: 15%;\n    font-size: 5rem;\n    color: white;\n    font-weight: 600;\n}\n\n.continue-link { \n    display: inline-block;\n    margin-top: 20px;\n    font-size: 1.5rem;\n    color: #364C63; \n    color: white;\n    text-decoration: none; \n    background-color: #d85939;\n    padding: 10px; \n    border-radius: 10px; \n    transition: background-color 0.3s; \n    cursor: pointer;\n}\n\n.continue-link:hover {\n    background-color: #fa3a0a; \n    transform: translateY(2px); \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
